// homeDashboards.js — which dashboard a user's home page shows instead of the personal one.
//
// Owner 2026-05-06: Elroi sees the sales-technicians dashboard on his home page.
// Owner 2026-10-12: אמיתי שמואל, אפרים שמואל and מני ברזל see the team revenue dashboard
// ("דשבורד מחזור לפי צוותים", /accounting/team-revenue) the same way.
//
// Keyed by the CRM user's id / username — each is unique in `users` (measured 2026-10-12).
// This decides only what the home page SHOWS. Reading the team revenue data stays admin +
// accounting (backend routers/team_revenue.py) — owner 2026-10-12: אמיתי שמואל's profile
// becomes הנהלת חשבונות rather than a per-user exception in the backend.
// Everyone else: the personal dashboard.

export const HOME_DASHBOARDS = {
  'elroei@afikim-water.co.il': 'sales_technicians',   // אלרואי
  'amitai@afikim.com': 'team_revenue',                // אמיתי שמואל
  'es@afikim.com': 'team_revenue',                    // אפרים שמואל
  'meni@afikim.my': 'team_revenue',                   // מני ברזל
};

export function homeDashboardFor(user) {
  if (!user) return null;
  for (const key of [user.id, user.username]) {
    const k = String(key || '').trim().toLowerCase();
    if (k && HOME_DASHBOARDS[k]) return HOME_DASHBOARDS[k];
  }
  return null;
}
